<!--
 * @Author: ken yang
 * @Date: 2022-11-28 09:08:14
 * @LastEditTime: 2023-01-30 13:59:56
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_admin/src/layout/components/AppMain.vue
-->
<template>
  <Column
    wrap-class="app-main h-100b w-100b column"
    :noresize="true"
  >
    <router-view v-slot="{ Component }" class=" p-10 radius-6">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="tagList">
          <Component
            :is="Component"
            class="component w-100b"
          />
        </keep-alive>
      </transition>
    </router-view>
  </Column>
</template>
<script setup>
const userStore = useUserStore()
const tagList = $computed(() => {
  const copyTagList = [...userStore.tagList]

  const tagComLists = copyTagList.filter((obj) => { // 过滤出所有的二阶路由
    return obj.fullPath.split('/')?.length === 3
  }).map((item) => {
    const arr = item.fullPath.split('/')
    return arr[arr.length - 1]
  })

  const isHasThirdMenu = copyTagList.some((obj) => { // 如果有三级菜单 就缓存view组件
    const arr = obj.fullPath.split('/')
    return arr.length === 4
  })
  if (isHasThirdMenu)tagComLists.push('view')

  return tagComLists
})
</script>
<style lang="scss" scoped>
.app-main{
  box-sizing: border-box;
  background-color: #F7F8FA;
}
</style>
